// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3xb25","noInteraction":"EventWrapper_noInteraction__2x_IM","pointerPassthrough":"EventWrapper_pointerPassthrough__2iKfy"};